export const initialSeason: Season = {
	_id: undefined,
	name: "",
	startDate: "",
	endDate: "",
	isActive: false,
};

export const initialLeague: League = {
	name: "",
	_id: undefined,
	description: undefined,
	sport: "",
	series: "",
	admins: [],
	privacy: "public",
	prize: undefined,
	losing_prize: undefined,
	roundPrize: undefined,
	teams: [],
	dateCreated: undefined,
	featured: undefined,
	season: undefined,
	image: undefined,
	imageMobile: undefined,
	overallPrizeDescription: undefined,
	roundImage: undefined,
	roundImageMobile: undefined,
	roundPrizeDescription: undefined,
	roundPrizeUrl: undefined,
	overallPrizeUrl: undefined,
};

export const initialSeries: Series = {
	name: "",
	description: undefined,
	_id: "",
};

export const initialSport: Sport = {
	name: "",
	shortName: undefined,
	description: undefined,
	_id: "",
};

export const initialLeagueWithSportsAndSeries: LeagueWithSportsAndSeries = {
	name: "",
	_id: undefined,
	description: undefined,
	sport: initialSport,
	series: initialSeries,
	admins: [],
	privacy: "public",
	prize: undefined,
	losing_prize: undefined,
	roundPrize: undefined,
	teams: [],
	dateCreated: undefined,
	featured: undefined,
	season: undefined,
	image: undefined,
	imageMobile: undefined,
	overallPrizeDescription: undefined,
	roundImage: undefined,
	roundImageMobile: undefined,
	roundPrizeDescription: undefined,
	roundPrizeUrl: undefined,
	overallPrizeUrl: undefined,
};

export const initialVideo: Video = {
	title: "",
	description: "",
	videoUrl: "",
	thumbnailUrl: undefined,
	createdAt: new Date(),
	featured: false,
	podcast: false,
	scrollbar: false,
	order: 0,
};

export const initialEvent: Event = {
	name: "",
	_id: undefined,
	sport: {
		name: "",
		shortName: undefined,
		_id: "",
		description: undefined,
	},
	date: new Date(),
	location: "",
	series: {
		name: "",
		_id: "",
		description: undefined,
	},
	description: undefined,
	country: "",
	eventImage: undefined,
	trackImage: undefined,
	eventUrl: undefined,
	round: undefined,
	season: undefined,
};

export const initialTeam: Team = {
	name: undefined,
	_id: undefined,
	owner: "",
	leagues: [],
	riders: [],
	sport: "",
	series: "",
	season: "",
	selectedTeam: undefined,
	bestTrickRiderMen: undefined,
	PeoplesChoiceRiderMen: undefined,
	bestTrickRiderWomen: undefined,
	PeoplesChoiceRiderWomen: undefined,
	snapshots: undefined,
	dateCreated: undefined,
};

export const initialTeamWithRider: TeamWithRider = {
	name: undefined,
	_id: "",
	owner: "",
	leagues: [],
	riders: [],
	sport: "",
	series: "",
	season: "",
	selectedTeam: undefined,
	snapshots: undefined,
	dateCreated: undefined,
};

export const initialTeamComplete: TeamComplete = {
	name: undefined,
	_id: "",
	owner: "",
	leagues: [],
	riders: [],
	sport: {
		name: "",
		shortName: undefined,
		_id: "",
		description: undefined,
	},
	series: {
		name: "",
		_id: "",
		description: undefined,
	},
	season: "",
	selectedTeam: undefined,
	snapshots: undefined,
	dateCreated: undefined,
};

export const initialRider: Rider = {
	first_name: "",
	last_name: "",
	_id: undefined,
	sports: undefined,
	series: undefined,
	country: undefined,
	href: undefined,
	DOB: undefined,
	team: undefined,
	team_short: undefined,
	gender: undefined,
	status: undefined,
	imageUrl: "",
	ratings: [],
	teamHistory: [],
	featured: false,
};

export const initialRoundWinner: RoundWinner = {
	_id: undefined,
	leagueId: "",
	eventId: initialEvent,
	userId: "",
	userName: "",
	totalPoints: 0,
	snapshotId: "",
};

export const initialUser: User = {
	username: "",
	_id: undefined,
	email: "",
	password: null,
	role: "",
	themePreference: "dark",
	avatarId: "",
	favoriteSportId: undefined,
	favoriteSeriesId: undefined,
	isActive: undefined,
	agreeToMarketing: true,
	agreeToTerms: true,
	isGmail: false,
	resetPasswordToken: undefined,
	resetPasswordExpires: undefined,
};

export const initialLeaderboard: Leaderboard = {
	leagueId: "",
	_id: undefined,
	teams: [],
};

export const initialBrandTeam: BrandTeam = {
	name: "",
	_id: undefined,
	shortName: undefined,
	country: undefined,
	sponsor: undefined,
	color: undefined,
	isActive: undefined,
	featured: false,
	imageUrl: "",
	logoUrl: "",
	source: "",
};

export const initialGameMode: GameMode = {
	_id: undefined,
	name: "",
	description: "",
	numberOfMen: 0,
	numberOfWomen: 0,
	value: undefined,
};
export const initialGameModeAssignment: GameModeAssignment = {
	sport: initialSport,
	series: initialSeries,
	gameMode: "",
};

export const initialSnapshot: Snapshot = {
	_id: undefined,
	team: "",
	event: "",
	sport: "",
	series: "",
	riders: [],
	selectedTeam: undefined,
	name: "",
	dateCreated: undefined,
};

export const initialSnapshotWithRider: SnapshotWithRider = {
	_id: undefined,
	team: "",
	event: "",
	sport: initialSport,
	series: initialSeries,
	riders: [],
	selectedTeam: undefined,
	name: "",
	dateCreated: undefined,
};

export interface Season {
	_id?: string;
	name: string;
	startDate: string;
	endDate: string;
	isActive: boolean;
}

export interface CreateLeague {
	name: string;
	description?: string;
	sport: string;
	series: string;
	privacy: "public" | "private";
	season: string;
	prize?: string;
	losing_prize?: string;
}

export interface League {
	name: string;
	_id?: string;
	description?: string;
	sport: string;
	series: string;
	admins: string[];
	privacy: "public" | "private";
	prize?: string;
	losing_prize?: string;
	roundPrize?: string;
	teams: string[];
	dateCreated?: Date;
	featured?: boolean;
	season?: string;
	image?: string;
	imageMobile?: string;
	overallPrizeDescription?: string;
	roundImage?: string;
	roundImageMobile?: string;
	roundPrizeDescription?: string;
	roundPrizeUrl?: string;
	overallPrizeUrl?: string;
}

export interface LeagueWithSportsAndSeries {
	name: string;
	_id?: string;
	description?: string;
	sport: Sport;
	series: Series;
	admins: string[];
	privacy: "public" | "private";
	prize?: string;
	losing_prize?: string;
	roundPrize?: string;
	teams: string[];
	dateCreated?: Date;
	featured?: boolean;
	season?: string;
	image?: string;
	imageMobile?: string;
	overallPrizeDescription?: string;
	roundImage?: string;
	roundImageMobile?: string;
	roundPrizeDescription?: string;
	roundPrizeUrl?: string;
	overallPrizeUrl?: string;
}

export interface Event {
	name: string;
	_id?: string;
	sport: Sport;
	date: Date;
	location: string;
	series: Series;
	description?: string;
	country: string;
	eventImage?: string;
	trackImage?: string;
	eventUrl?: string;
	round?: number;
	season?: string;
}

export interface Team {
	name?: string;
	_id?: string;
	owner: string;
	leagues: string[];
	riders: {
		rider: string;
		rank: number;
	}[];
	sport: string;
	series: string;
	season: string;
	selectedTeam?: string;
	bestTrickRiderMen?: string;
	PeoplesChoiceRiderMen?: string;
	bestTrickRiderWomen?: string;
	PeoplesChoiceRiderWomen?: string;
	snapshots?: string[];
	dateCreated?: Date;
}

export interface TeamWithRider {
	name?: string;
	_id: string;
	owner: string;
	leagues: string[];
	riders: RiderInTeam[];
	sport: string;
	series: string;
	season: string;
	selectedTeam?: string;
	bestTrickRiderMen?: string;
	bestTrickRiderWomen?: string;
	PeoplesChoiceRiderMen?: string;
	PeoplesChoiceRiderWomen?: string;
	snapshots?: string[];
	dateCreated?: Date;
}

export interface RiderInTeam {
	rider: Rider;
	rank: number;
}

export interface TeamComplete {
	name?: string;
	_id: string;
	owner: string;
	leagues: League[];
	riders: {
		rider: Rider;
		rank: number;
	}[];
	sport: Sport;
	series: Series;
	season: string;
	selectedTeam?: string;
	bestTrickRiderMen?: string;
	bestTrickRiderWomen?: string;
	PeoplesChoiceRiderMen?: string;
	PeoplesChoiceRiderWomen?: string;
	snapshots?: string[];
	dateCreated?: Date;
}

export interface Rider {
	first_name: string;
	last_name: string;
	_id?: string;
	sports?: string[];
	series?: string[];
	country?: string;
	href?: string;
	DOB?: string;
	team?: string;
	team_short?: string;
	gender?: string;
	status?: string;
	ratings?: {
		sport: string;
		rating?: number;
	}[];
	teamHistory?: TeamHistory[];
	featured?: boolean;
	imageUrl?: string;
}

export interface MostPickedRiderCount {
	rider: Rider;
	count: number;
}

export interface RiderWithSports {
	first_name: string;
	last_name: string;
	_id?: string;
	sports?: string[];
	series?: string[];
	country?: string;
	href?: string;
	DOB?: string;
	team?: string;
	team_short?: string;
	gender?: string;
	status?: string;
	ratings?: {
		sport: string;
		rating?: number;
	}[];
	teamHistory?: TeamHistory[];
	featured?: boolean;
	imageUrl?: string;
}

export interface TeamHistory {
	team: string;
	season: string;
}

export interface Rating {
	sport: string;
	rating?: number;
	_id?: string;
}

export interface Series {
	name: string;
	description?: string;
	_id: string;
}

export interface Sport {
	name: string;
	shortName?: string;
	description?: string;
	_id: string;
}

export interface User {
	username: string;
	_id?: string;
	email: string;
	password?: string | null;
	role: string;
	themePreference?: "dark";
	avatarId?: string;
	favoriteSportId?: string;
	favoriteSeriesId?: string;
	isActive?: boolean;
	isGmail?: boolean;
	agreeToTerms?: boolean;
	agreeToMarketing?: boolean;
	resetPasswordToken?: string;
	resetPasswordExpires?: Date;
}

export interface Leaderboard {
	leagueId: string;
	_id?: string;
	teams?: LeaderboardTeam[];
}

export interface LeaderboardTeam {
	teamId: string;
	userId: string;
	userName: string;
	totalPoints: number;
	rank?: number;
}

export interface BrandTeam {
	name: string;
	_id?: string;
	shortName?: string;
	country?: string;
	sponsor?: string;
	color?: string;
	isActive?: boolean;
	featured?: boolean;
	imageUrl?: string;
	logoUrl?: string;
	source?: string;
}

export type FeaturedType = "rider" | "brandTeam";

export interface FeaturedConfig {
	_id?: string;
	type: FeaturedType;
	sport?: Sport | string | null;
	series?: Series | string | null;
	description?: string;
	rider?: Rider | null;
	brandTeam?: BrandTeam | null;
	createdAt?: Date | string;
	updatedAt?: Date | string;
}

export interface Video {
	_id?: string;
	title: string;
	description?: string;
	videoUrl: string;
	thumbnailUrl?: string;
	createdAt?: Date;
	featured?: boolean;
	podcast?: boolean;
	scrollbar?: boolean;
	order?: number;
}

export interface GameMode {
	_id?: string;
	name: string;
	description: string;
	numberOfMen: number;
	numberOfWomen: number;
	value?: number;
}

export interface GameModeAssignmentShallow {
	sport: string;
	series: string;
	gameMode: string;
}

export interface GameModeAssignment {
	sport: Sport;
	series: Series;
	gameMode: string;
}

export interface Result {
	_id?: string;
	event: string;
	event_date: Date;
	rider: string;
	sport: string;
	series: string;
	season?: string;
	qualifying_data?: {
		split1?: string;
		split2?: string;
		time?: string;
		score?: number;
		points?: number;
		rank?: number;
	};
	semis_data?: {
		split1?: string;
		split2?: string;
		time?: string;
		score?: number;
		points?: number;
		rank?: number;
	};
	finals_data?: {
		split1?: string;
		split2?: string;
		time?: string;
		score?: number;
		points?: number;
		rank?: number;
	};
	total_points?: number;
	bestTrickRiderMen?: boolean;
	peoplesChoiceRiderMen?: boolean;
	PeoplesChoiceRiderMen?: boolean;
	bestTrickRiderWomen?: boolean;
	peoplesChoiceRiderWomen?: boolean;
	PeoplesChoiceRiderWomen?: boolean;
}

export interface ResultWithRider {
	_id?: string;
	event: string;
	event_date: Date;
	rider: Rider;
	sport: string;
	series: string;
	qualifying_data?: {
		split1?: string;
		split2?: string;
		time?: string;
		score?: number;
		points?: number;
		rank?: number;
	};
	semis_data?: {
		split1?: string;
		split2?: string;
		time?: string;
		score?: number;
		points?: number;
		rank?: number;
	};
	finals_data?: {
		split1?: string;
		split2?: string;
		time?: string;
		score?: number;
		points?: number;
		rank?: number;
	};
	total_points?: number;
	bestTrickRiderMen?: boolean;
	PeoplesChoiceRiderMen?: boolean;
	bestTrickRiderWomen?: boolean;
	PeoplesChoiceRiderWomen?: boolean;
}
export interface OverallRank {
	riderId: string;
	rider_first_name: string;
	rider_last_name: string;
	rider_gender?: string;
	rider_country?: string;
	total_points: number;
}

export interface EditTeamRider {
	rank: number;
	rider: Rider;
	_id?: string;
}

export interface CreateTeamInput {
	league?: string | null;
	riders: EditTeamRider[];
	selectedTeam: string;
	bestTrickRiderMen?: string;
	PeoplesChoiceRiderMen?: string;
	bestTrickRiderWomen?: string;
	PeoplesChoiceRiderWomen?: string;
	name?: string;
	sport: string;
	series: string;
	[additionalFields: string]: any;
}

export interface GetTeamsInput {
	sport?: string;
	series?: string;
	season?: string;
	leagueId?: string;
}

export interface Snapshot {
	_id?: string;
	team: string;
	event: string;
	sport: string;
	series: string;
	riders: {
		rider: string;
		rank: number;
	}[];
	selectedTeam?: string;
	name: string;
	bestTrickRiderMen?: string;
	bestTrickRiderWomen?: string;
	PeoplesChoiceRiderMen?: string;
	PeoplesChoiceRiderWomen?: string;
	dateCreated?: Date;
}

export interface SnapshotWithEventandRider {
	_id?: string;
	team: string;
	event: Event;
	sport: string;
	series: string;
	riders: {
		rider: Rider;
		rank: number;
	}[];
	selectedTeam?: string;
	bestTrickRiderMen?: Rider;
	PeoplesChoiceRiderMen?: Rider;
	bestTrickRiderWomen?: Rider;
	PeoplesChoiceRiderWomen?: Rider;
	name: string;
	dateCreated?: Date;
}

export interface SnapshotWithRider {
	_id?: string;
	team: string;
	event: string;
	sport: Sport;
	series: Series;
	riders: {
		rider: Rider;
		rank: number;
	}[];
	selectedTeam?: string;
	bestTrickRiderMen?: string;
	PeoplesChoiceRiderMen?: string;
	bestTrickRiderWomen?: string;
	PeoplesChoiceRiderWomen?: string;
	name: string;
	dateCreated?: Date;
}

export interface SnapshotSummary {
	_id?: string;
	name: string;
	sport: Sport;
	series: Series;
	dateCreated?: Date;
	snapshotCount: number;
}

export interface TeamResultRider {
	rider: string;
	rank?: number;
	points: number;
}

export interface TeamResultRiderWithRider {
	rider: Rider;
	rank?: number;
	points: number;
}

export interface TeamResultWithRider {
	_id?: string;
	name: string;
	brandTeamId?: string;
	event: string;
	sport?: string;
	series?: string;
	points?: number;
	totalTeamPoints?: number;
	riders: TeamResultRiderWithRider[];
	dateCreated?: Date;
}
export interface TeamResult {
	_id?: string;
	name: string;
	brandTeamId?: string;
	event: string;
	sport?: string;
	series?: string;
	points?: number;
	totalTeamPoints?: number;
	riders: TeamResultRider[];
	dateCreated?: Date;
}

export interface BestCountry {
	country: string;
	count: number;
}

export interface RiderValueRatio {
	riderId: string;
	rider_first_name: string;
	rider_last_name: string;
	total_points: number;
	rider_rating: number;
	ratio: number;
}

export interface RoundWinner {
	_id?: string;
	leagueId: string;
	eventId: Event;
	userId: string;
	userName: string;
	totalPoints: number;
	snapshotId: string;
}
